import type { Locale } from "@/i18n/types";

const MONTHS: Record<Locale, readonly string[]> = {
  en: ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"],
  // Brazilian abbreviations are lowercase by convention.
  pt: ["jan", "fev", "mar", "abr", "mai", "jun", "jul", "ago", "set", "out", "nov", "dez"],
};

const PRESENT: Record<Locale, string> = {
  en: "Present",
  pt: "Hoje",
};

/** `2022-07` → `Jul 2022` / `jul 2022`. Invalid input is returned untouched. */
export function formatMonth(iso: string, locale: Locale = "en"): string {
  const match = /^(\d{4})-(\d{2})$/.exec(iso);
  if (!match) return iso;
  const month = MONTHS[locale][Number(match[2]) - 1];
  return month ? `${month} ${match[1]}` : iso;
}

export function formatPeriod(
  period: { start: string; end: string | null },
  locale: Locale = "en",
): string {
  const end = period.end ? formatMonth(period.end, locale) : PRESENT[locale];
  return `${formatMonth(period.start, locale)} — ${end}`;
}

export function formatPeriods(
  periods: readonly { start: string; end: string | null }[],
  locale: Locale = "en",
): string {
  return periods.map((period) => formatPeriod(period, locale)).join(" · ");
}
